import moment from 'moment';
import 'moment/locale/it';
import Campagne from 'pages/admin/campagne';
import HomeDashboard from 'pages/admin/dashboard/home-dashboard';
import Ricerca from 'pages/admin/ricerca';
import DettaglioCertificazione from 'pages/admin/ricerca/dettaglio-certificazione';
import RicercaAnagrafe from 'pages/admin/ricerca/ricerca-anagrafe';
import { setAccessTokenAdminAction } from 'pages/admin/_redux/actions';
import { accessTokenAdminSelector } from 'pages/admin/_redux/selectors';
import CertificazioneCliente from 'pages/cliente';
import { setAccessTokenClienteAction } from 'pages/cliente/_redux/actions';
import { accessTokenClienteSelector } from 'pages/cliente/_redux/selectors';
import ErrorPage from 'pages/error-page';
import LoginAdmin from 'pages/login-admin';
import LoginAdminSSO from 'pages/login-admin-sso';
import LoginCliente from 'pages/login-cliente';
import Test from 'pages/test';
import React from 'react';
import { HashRouter, Redirect, Route, Switch } from "react-router-dom";
import { useAppDispatch, useAppSelector } from 'store/hooks';
import './App.scss';
import Error from './components/error';
import Loader from './components/loader';
import Footer from './core/footer';
import Header from './core/header';
import Sidebar from './core/sidebar';

moment.locale('it');

export const MOCK = false;

const App: React.FC = () => {

  const dispatch = useAppDispatch();

  const accessTokenAdmin = useAppSelector(accessTokenAdminSelector);
  const accessTokenCliente = useAppSelector(accessTokenClienteSelector);

  const accessTokenAdminLocalStorage = localStorage.getItem('accessTokenAdmin');
  if (!accessTokenAdmin) {
    if (accessTokenAdminLocalStorage) {
      dispatch(setAccessTokenAdminAction(accessTokenAdminLocalStorage));
    }
  }

  const accessTokenClienteLocalStorage = localStorage.getItem('accessTokenCliente');
  if (!accessTokenCliente) {
    if (accessTokenClienteLocalStorage) {
      dispatch(setAccessTokenClienteAction(accessTokenClienteLocalStorage));
    }
  }

  return (
    <div>

      <HashRouter>
        <Route path="/login-admin" component={LoginAdmin} exact />
        <Route path="/login-admin/:userToken" component={LoginAdmin} exact />
        <Route path="/login-admin-sso" component={LoginAdminSSO} />

        <Route path="/test" component={Test} exact />

        <Route path="/error-page" component={ErrorPage} exact />
        <Route path="/" exact>
          <Redirect to='/admin/dashboard' />
        </Route>

        <Route path='/admin' render={() => {
          return (
            (accessTokenAdmin || accessTokenAdminLocalStorage) ? (
              <div>
                <Sidebar />
                <div className="wrapper d-flex flex-column min-vh-100">
                  <div className="body flex-grow-1 px-0">
                    <Header />
                    <div className="container-fluid">
                      <Switch>
                        <Route path="/admin/ricerca-anagrafe-cedacri" component={RicercaAnagrafe} />
                        <Route path="/admin/ricerca" component={Ricerca} />
                        <Route path="/admin/ricerca/:ndg/:id" component={DettaglioCertificazione} />
                        <Route path="/admin/dashboard" component={HomeDashboard} exact />
                        <Route path="/admin/cruscotto-campagne" component={HomeDashboard} exact />
                        <Route path="/admin/campagne" component={Campagne} />
                        <Route path="/admin/*">
                          <Redirect to='/admin/dashboard' />
                        </Route>
                      </Switch>
                    </div>
                  </div>
                  <Footer />
                </div>
              </div>
            ) : (
              <>
                <Redirect to="/error-page" />
              </>
            )
          )
        }} />

        <Route path="/login-cliente" component={LoginCliente} />

        <Route path='/cliente' render={() => {
          return (
            (accessTokenCliente || accessTokenClienteLocalStorage) ? <CertificazioneCliente /> : <Redirect to="/error-page" />
          )
        }} />

        <Error />
        <Loader />

      </HashRouter>

    </div>
  );
}

export default App;
